import React from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from './styles';
import { DispatchStatus, DispatchDragNDropTypes } from '~/utils';
import PF2MDispatchIconMaker from '../PF2MDispatchIconMaker';
import PF2MTooltip from '../PF2MTooltip';

const iconTypes = {
  stack: 'material',
  excavator: 'excavator',
  truck: 'truckEmpty',
};

const altForIconType = {
  stack: 'Destino',
  excavator: 'Escavadeira',
  truck: 'Caminhão',
};

const PF2MDispatchIcon = ({
  itemType,
  customStyles,
  classes,
  iconType,
  subtitle,
  warningType = null,
  ...rest
}) => (
  <div
    style={{
      height: 'fit-content',
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      cursor: 'pointer',
      ...customStyles,
    }}
    {...rest}
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
      }}
    >
      <div style={{ position: 'relative', top: 0, left: 0 }}>
        <PF2MDispatchIconMaker
          iconName={iconTypes[iconType]}
          settings={{
            iconSize: 50,
            alt: altForIconType[iconType],
            warnings: warningType ? [{
              icon: 'attention',
              position: 'top-right',
              alt: 'Atenção',
            }] : null,
          }}
        />
      </div>
      {subtitle
        && (
          <PF2MTooltip
            title={subtitle}
            PopperProps={{ disablePortal: true }}
          >
            <div
              className={classes.labelTypeSelector}
              style={{
                width: 50,
                fontSize: '14px',
                textAlign: 'center',
                color: 'rgb(100, 120, 134)',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              {subtitle}
            </div>
          </PF2MTooltip>
        )
      }
    </div>
  </div>
);

PF2MDispatchIcon.propTypes = {
  classes: PropTypes.object,
  customStyles: PropTypes.object,
  itemType: PropTypes.string,
  onClick: PropTypes.func,
  status: PropTypes.string,
  warningType: PropTypes.string,
  subtitle: PropTypes.string,
  iconType: PropTypes.string,
};

PF2MDispatchIcon.defaultProps = {
  classes: {},
  customStyles: {},
  status: DispatchStatus.OP,
  itemType: DispatchDragNDropTypes.TRUCK,
  onClick: () => null,
  warningType: '',
  subtitle: '',
  iconType: 'stack',
};

export default withStyles(styles)(PF2MDispatchIcon);
